var KeyMirror = require('keymirror');
var ApplicationConstants = require('./ApplicationConstants.js');

const IDVerificationLabels = {
    SELECT_DOCUMENT_TYPE_READONLY_LABEL: 'Document type',
    SELECT_DOCUMENT_TYPE_LABEL: 'Select document type',
    VERIFIED_FROM_LABEL: 'Verified from',
    SELECT_DOCUMENT_TYPE_OPTION: 'Select',
    DOCUMENT_ISSUER: 'Name of document issuer',
    ISSUE_STATE: 'Issuing state',
    ISSUE_DATE: 'Issue date',
    EXPIRY_DATE: 'Expiry date',
    DOCUMENT_NUMBER: 'Document number',
    ACCREDITED_ENGLISH_TRANSLATION: 'Accredited English translation'
};

const STATE_OPTIONS = [
    {
        label: 'NSW',
        value: 'NSW'
    },
    {
        label: 'VIC',
        value: 'VIC'
    },
    {
        label: 'QLD',
        value: 'QLD'
    },
    {
        label: 'SA',
        value: 'SA'
    },
    {
        label: 'WA',
        value: 'WA'
    },
    {
        label: 'NT',
        value: 'NT'
    },
    {
        label: 'TAS',
        value: 'TAS'
    },
    {
        label: 'ACT',
        value: 'ACT'
    }
];

const DOCUMENT_TYPES = KeyMirror({
    PRIMARY_PHOTOGRAPHIC: null,
    PRIMARY_NON_PHOTOGRAPHIC: null,
    SECONDARY: null,
    OTHER: null
});

const AVAILABLE_ACCT_TYPES = [
    ApplicationConstants.AccountTypeCodes.INDIVIDUAL,
    ApplicationConstants.AccountTypeCodes.JOINT,
    ApplicationConstants.AccountTypeCodes.SOLE_TRADER
];

const DOCUMENT_NUMBER_ID = 'number';

const IDV_DOCUMENT_MODEL = [
    {
        type: 'Australian Driver Licence',
        typeDescription: 'Drivers licence issued in Australia that contains a photograph of the person in whose name the document is issued',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issueState',
                model: 'issueState',
                label: 'Issuing state',
                validationRule: 'MANDATORY',
                component: 'SELECT',
                selectOptions: STATE_OPTIONS,
                defaultValue: '',
                mandatory: true
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                validation: 'expiryDate',
                maxLength: 10,
                mandatory: true
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_PHOTOGRAPHIC,
        sortIndex: 1,
        reactKey: 'ADL',
        isMain: true,
        id: null
    },
    {
        type: 'New Zealand Drivers Licence',
        typeDescription: 'Drivers licence issued in New Zealand that contains a photograph of the person in whose name the document is issued',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                defaultValue: 'Land Transport New Zealand',
                mandatory: true
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_PHOTOGRAPHIC,
        sortIndex: 0,
        reactKey: 'NDL',
        isMain: true,
        id: null
    },
    {
        type: 'Australian passport',
        typeDescription: 'Australian passport issued by the Commonwealth, which has not been expired for 2 years or more',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                validation: 'issueDate',
                mandatory: true,
                maxLength:10
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                validation: 'expiryDateMinus2Years',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                mandatory: true,
                maxLength:10
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                defaultValue: 'Australian Government',
                mandatory: true
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_PHOTOGRAPHIC,
        sortIndex: 2,
        reactKey: 'APP',
        isMain: true,
        id: null
    },
    {
        type: 'Other',
        documentType: DOCUMENT_TYPES.OTHER,
        sortIndex: 3,
        reactKey: 'OTH',
        isMain: true,
        id: null
    },
    {
        type: 'Proof of age card',
        typeDescription: 'Proof of Age cards issued under a law of a state or territory (a NSW Photo Card as of 13 December 2008) that contains a photograph of the person in whose name the document is issued',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issueState',
                model: 'issueState',
                label: 'Issuing state',
                validationRule: 'MANDATORY',
                component: 'SELECT',
                selectOptions: STATE_OPTIONS,
                defaultValue: '',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                validation: 'issueDate',
                mandatory: false,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_PHOTOGRAPHIC,
        sortIndex: 4,
        reactKey: 'GID',
        id: null
    },
    {
        type: 'NSW Photo Card and Birth Card or WA Photo Card',
        typeDescription: 'NSW Photo Card and Birth card or a WA Photo card (not currently available in other states)',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issueState',
                model: 'issueState',
                label: 'Issuing state',
                defaultValue: '',
                component: 'SELECT',
                selectOptions: [
                    {
                        label: 'NSW',
                        value: 'NSW'
                    },
                    {
                        label: 'WA',
                        value: 'WA'
                    }
                ],
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_PHOTOGRAPHIC,
        sortIndex: 5,
        reactKey: 'PHC',
        id: null
    },
    {
        type: 'International passport',
        typeDescription: 'International Passport or similar document issued for the purpose of international travel - Contains a photograph and signature of the person in whose name the document is issued; Is issued by a foreign government, the United Nations (UN) or an agency of the UN; and if written in language not understood by the person carrying ouy the verification, accompained by an Enlish translation from an accredited translator.',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'translation',
                model: 'accreditedEnglish',
                label: 'Accredited English translation',
                placeholder: '',
                className: 'form-input',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'NoApplicable', name: 'N/A' }, { id: 'Sighted', name: 'Sighted' }],
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_PHOTOGRAPHIC,
        sortIndex: 6,
        reactKey: 'FPP',
        id: null
    },
    {
        type: 'Firearms licence issued under law (All States)',
        typeDescription: 'Firearms licence issued under law (All States)',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issueState',
                model: 'issueState',
                label: 'Issuing state',
                validationRule: 'MANDATORY',
                component: 'SELECT',
                selectOptions: STATE_OPTIONS,
                defaultValue: '',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_PHOTOGRAPHIC,
        sortIndex: 7,
        reactKey: 'FAL',
        id: null
    },
    {
        type: 'NSW Security licence (Class 1/2 only)',
        typeDescription: 'NSW Security Licence issued by NSW Police that contains the full name, date of birth and photograph of the person in whose name the document is issued',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                defaultValue: 'NSW Police Force',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_PHOTOGRAPHIC,
        sortIndex: 8,
        reactKey: 'NSL',
        id: null
    },
    {
        type: 'Foreign national/UN ID card',
        typeDescription: 'A national identity card issued by a Foreign government, the UN or any agency of the UN contains a photograph and signature of the person in whose name the document is issued.If written in language not understood by the person carrying out the verification, accompained by an English transaltion.',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'translation',
                model: 'accreditedEnglish',
                label: 'Accredited English translation',
                placeholder: '',
                className: 'form-input',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'NoApplicable', name: 'N/A' }, { id: 'Sighted', name: 'Sighted' }],
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_PHOTOGRAPHIC,
        sortIndex: 9,
        reactKey: 'FNI',
        id: null
    },
    {
        type: 'Australian birth certificate',
        typeDescription: 'Birth certificate or birth extract issued by an Australian State or Territory',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issueState',
                model: 'issueState',
                label: 'Issuing state',
                validationRule: 'MANDATORY',
                component: 'SELECT',
                selectOptions: STATE_OPTIONS,
                defaultValue: '',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_NON_PHOTOGRAPHIC,
        sortIndex: 10,
        reactKey: 'ABC',
        id: null
    },
    {
        type: 'Foreign birth certificate',
        typeDescription: 'Birth certificate or birth extract issued by a foreign government, the United Nations or an agency of the UN',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'translation',
                model: 'accreditedEnglish',
                label: 'Accredited English translation',
                placeholder: '',
                className: 'form-input',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'NoApplicable', name: 'N/A' }, { id: 'Sighted', name: 'Sighted' }],
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_NON_PHOTOGRAPHIC,
        sortIndex: 11,
        reactKey: 'FBC',
        id: null
    },
    {
        type: 'Citizenship certificate issued by the Commonwealth',
        typeDescription: 'Citizenship certificate issued by the Commonwealth ',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                defaultValue: 'Australian Government',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_NON_PHOTOGRAPHIC,
        sortIndex: 12,
        reactKey: 'ACC',
        id: null
    },
    {
        type: 'Citizenship certificate issued by a foreign government',
        typeDescription: 'Citizenship certificate issued by a foreign government. If written in language not undestood by the person carrying out the verification, accompained by an English translation from an accredited translator.',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'translation',
                model: 'accreditedEnglish',
                label: 'Accredited English translation',
                placeholder: '',
                className: 'form-input',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'NoApplicable', name: 'N/A' }, { id: 'Sighted', name: 'Sighted' }],
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_NON_PHOTOGRAPHIC,
        sortIndex: 13,
        reactKey: 'FCC',
        id: null
    },
    {
        type: 'Centrelink pension/health card',
        typeDescription: 'Pension card, health care card or a Card issued by CentreLink that entitles the person whose name the card is issued, to financial benefits',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                defaultValue: 'Australian Government',
                mandatory: true
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_NON_PHOTOGRAPHIC,
        sortIndex: 14,
        reactKey: 'CPC',
        id: null
    },
    {
        type: 'Australian driver licence (without photo)',
        typeDescription: 'Drivers licence issued in Australia that does not contain a photograph of the person in whose name the document is issued',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issueState',
                model: 'issueState',
                label: 'Issuing state',
                validationRule: 'MANDATORY',
                component: 'SELECT',
                selectOptions: STATE_OPTIONS,
                defaultValue: '',
                mandatory: true
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                mandatory: true,
                maxLength:10
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.PRIMARY_NON_PHOTOGRAPHIC,
        sortIndex: 15,
        reactKey: 'ADC',
        id: null
    },
    {
        type: 'Driver licence issued overseas',
        typeDescription: 'Drivers licence issued overseas',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                mandatory: true,
                maxLength:10
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'translation',
                model: 'accreditedEnglish',
                label: 'Accredited English translation',
                placeholder: '',
                className: 'form-input',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'NoApplicable', name: 'N/A' }, { id: 'Sighted', name: 'Sighted' }],
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.SECONDARY,
        sortIndex: 16,
        reactKey: 'FDL',
        id: null
    },
    {
        type: 'Document issued by Commonwealth/State/Territory pertaining to provision of financial benefits',
        typeDescription: 'A document issued by the Commonwealth or a State or Territory within the preceding 12 months that records the provision of financial benefits to the individual and which contains the individual’s name and residential address',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                placeholder: '',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.SECONDARY,
        sortIndex: 17,
        reactKey: 'AGD',
        id: null
    },
    {
        type: 'ATO Notice',
        typeDescription: 'A document issued by the Australian Taxation Office within the preceding 12 months that records a debt payable by the individual to the Commonwealth (or by the Commonwealth to the individual), which contains the individual’s name and residential address. Block out the TFN before scanning, copying or storing this document.',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                className: 'form-input',
                component: 'TEXTINPUT',
                defaultValue: 'Australian Taxation Office',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength: 10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.SECONDARY,
        sortIndex: 18,
        reactKey: 'ATN',
        id: null
    },
    {
        type: 'Utility bill',
        typeDescription: 'A document issued by a local government body or utilities provider within the preceding 3 months which records the provision of services to that address or to that person (the document must contain the individual’s name and residential address)',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                className: 'form-input',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.SECONDARY,
        sortIndex: 19,
        reactKey: 'AUD',
        id: null
    },
    {
        type: 'Document from school principal (if under 18 years)',
        typeDescription: 'If under the age of 18, a notice that: was issued to the individual by a school principal within the preceding 3 months; and contains the name and residential address; and records the period of time that the individual attended that school',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                className: 'form-input',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: true,
                maxLength:10
            }
        ],
        documentType: DOCUMENT_TYPES.SECONDARY,
        sortIndex: 20,
        reactKey: 'SPN',
        id: null
    },
    {
        type: 'Security Guard/Crowd Safety Office identity card',
        typeDescription: 'Security Guard/Crowd Safety Office identity card',
        meta: [
            {
                id: 'verifiedFrom',
                model: 'verifiedFrom',
                label: 'Verified from',
                validationRule: 'MANDATORY',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'Original', name: 'Original', isHidden: false }, { id: 'CertifiedCopy', name: 'Certified copy', isHidden: false }],
                defaultValue: '',
                mandatory: true,
                placeholder: '',
                className: 'form-input',
                helpCopy: 'verifiedFromCopy'
            },
            {
                id: 'issuer',
                model: 'nameOfDocIssuer',
                label: 'Name of document issuer',
                placeholder: '',
                className: 'form-input',
                component: 'TEXTINPUT',
                mandatory: true
            },
            {
                id: 'issuedDate',
                model: 'issueDate',
                label: 'Issue date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: 'expiryDate',
                model: 'expiryDate',
                label: 'Expiry date',
                placeholder: 'DD/MM/YYYY',
                className: 'form-input-number',
                validation: 'expiryDate',
                crossFieldValidation: 'greaterThan',
                crossFieldValidationTarget: 'issueDate',
                component: 'TEXTINPUT',
                mandatory: false,
                maxLength:10
            },
            {
                id: DOCUMENT_NUMBER_ID,
                model: 'docNumber',
                label: 'Document number',
                className: 'form-input-number',
                component: 'TEXTINPUT',
                mandatory: false
            },
            {
                id: 'translation',
                model: 'accreditedEnglish',
                label: 'Accredited English translation',
                className: 'form-input',
                component: 'RADIOBUTTONLIST',
                options: [{ id: 'NoApplicable', name: 'N/A' }, { id: 'Sighted', name: 'Sighted' }],
                mandatory: true
            }
        ],
        documentType: DOCUMENT_TYPES.SECONDARY,
        sortIndex: 21,
        reactKey: 'SCS',
        id: null
    }
];

const VALIDATION_MESSAGES = {
    invalidIssueDate: 'Invalid issue date',
    invalidExpiryDate: 'Invalid expiry date',
    invalidDateFormat: 'Please enter a valid date in DD/MM/YYYY format',
    expiryDateFormat: 'Expiry date must be in dd/mm/yyyy format. Only number and hypen(/) allowed.',
    expiredIntPassport: 'We do not accept an expired International passport. Select another identification document.',
    expiredLicense: 'We do not accept an expired Australian or international license. Select another identification document.',
    futureIssueDate: 'Issue date cannot be a future date',
    pastExpiredDate: 'We do not accept expired identification documents. Please select another identification document.',
    expiredAusPassport: 'We do not accept an Australian Passport which has expired more than 2 years ago. Select another identification document.',
    missingFieldHeader: 'Missing {{label}}',
    missingFieldMessage: 'Please enter a {{label}}'
}

module.exports = {
    ActionTypes: KeyMirror({
        LOAD_USER_INFO: null,
        SET_IDVERIFICATION_VALIDATIONS: null,
        UPDATE_FILTERED_OPTIONS: null,
        REMOVE_IDVERIFICATION_DOCUMENT: null,
        CHANGE_IDVERIFICATION_DOCUMENT: null,
        UPDATE_IDVERIFICATION_DOCUMENT: null,
        START_EDIT_IDVERIFICATION_DOCUMENT: null,
        CANCEL_EDIT_IDVERIFICATION_DOCUMENT: null,
        FINISH_EDIT_IDVERIFICATION_DOCUMENT: null,
        CHECK_DIGITAL_CONSENT_ELIGIBILITY: null,
        GO_TO_ELECTRONIC_SUBMISSION_PAGE: null,
        UPDATE_NETCODE_MODEL: null,
        GO_TO_NETCODE_ENTRY_PAGE: null,
        SUBMIT_NETCODE: null,
        VALIDATE_NETCODE: null,
        RESEND_NETCODE: null,
        RECEIVE_SEND_NETCODE_RESULT: null,
        RECEIVE_VERIFY_NETCODE_RESULT: null,
        RECEIVE_VERIFY_MUTIPLE_NETCODE_RESULTS: null,
        GO_TO_CONGRATULATIONS: null,
        RECEIVE_CLIENT_IP_ADDRESS: null,
        TOGGLE_ELIGIBILITY_CHECK_COMPLETE: null
    }),

    Labels: IDVerificationLabels,

    Eligibility: {
        Eligible: 0,
        NotEligible: 1,
        NotRequired: 2
    },
    SendNetCodeResults: {
        LimitReached: 'limitReached',
        SendNetCodeSuccess: 'generated',
        InvalidMobileNo: 'invalidMobileNo',
        ServerError: 'serverError',
        Waiting: 'waiting',
        VerifyLimitReached: 'verifyLimitReached'
    },

    NetCodeModelIds: {
        Single: 'netCodeSingleEntry',
        Joint: 'netCodeJointEntry',
        TxtBx: 'txt-',
        ChckBx: 'chk-'
    },

    ValidationDetails: {
        Model: 'netCode',
        Rules: { netCode: 'required|numeric2|exactLength:6' },
        CustomAttributes: { netCode: 'SMS code' }
    },

    StateOptions: STATE_OPTIONS,

    DocumentTypes: DOCUMENT_TYPES,

    DocumentModels: IDV_DOCUMENT_MODEL,

    DocumentNumberId: DOCUMENT_NUMBER_ID,

    ReactKeyOther: 'OTH',

    DefaultDocType: 'ADL',

    kycTypeValues: {
        E_FORM: 'E',
        X_PLAN: 'X',
        COMM_SEE: 'C'
    },

    ConfirmButtonLabels: {
        SKIP: 'Skip',
        DISAGREE: 'Disagree',
        AGREE: 'Agree'
    },

    VerifyNetCodeResults: {
        LimitReached: 'limitReached',
        VerifyNetCodeSuccess: 'verified',
        InvalidMobileNo: 'invalidMobileNo',
        InvalidSmsCode: 'invalidSmsCode',
        ServerError: 'serverError',
        NotVerified: 'notVerified'
    },

    EformAvailableAccountTypes: AVAILABLE_ACCT_TYPES,

    ValidationMessages: VALIDATION_MESSAGES

};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/IDVerificationConstants.js